import styled from "styled-components";

import { Order } from "@sso/types";
import { PaymentGrid } from "@sso/ui/PaymentGrid";

import Price from "../Price/Price";

interface ItemTotalsProps {
  order: Order;
}

const TotalsGrid = styled(PaymentGrid)`
  width: 100%;
  gap: 20px;
  padding: 0.5rem 0.2rem;

  &:not(:last-child) {
    border-bottom: 1px solid #ccc; /* Adjust color and style as needed */
  }
`;

const TotalItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TotalPrice = styled(TotalItem)`
  grid-column: 3;
  text-align: right;
`;

const ItemTotals = ({ order }: ItemTotalsProps) => {
  return (
    <>
      <TotalsGrid>
        <TotalItem>Subtotal</TotalItem>
        <TotalPrice>
          <Price price={order.subtotal} currency={order.transactionCurrency} />
        </TotalPrice>
      </TotalsGrid>
      <TotalsGrid>
        <TotalItem>Tax</TotalItem>
        <TotalPrice>
          <Price price={order.totalTax} currency={order.transactionCurrency} />
        </TotalPrice>
      </TotalsGrid>

      <TotalsGrid>
        <TotalItem>Total</TotalItem>
        <TotalPrice>
          <Price price={order.total} currency={order.transactionCurrency} />
        </TotalPrice>
      </TotalsGrid>
    </>
  );
};

export default ItemTotals;
